import { shallowEqual, useSelector } from 'react-redux';
import cn from 'classnames';
import styles from './UserPage.scss';

export const UserStatusBadge = ({ userID }) => {
  const status = useSelector((state) => state.users.statuses[userID], shallowEqual);

  return (
    <div className={styles.statusBadge}>
      <span className={cn(styles.status, { [styles.online]: status?.isOnline })} />
      {status?.isOnline ? 'Онлайн' : 'Офлайн'}
    </div>
  );
};
